import { setHeader } from '@portal/repositories/securitySdkConfig';
import { browserName, osName } from 'react-device-detect';
import * as StorageService from '~/services/storage';

export const setHeaderDevice = (deviceId?: string) => {
  setHeader(StorageService.StorageItems.DEVICE_ID, deviceId ?? '', 'local');
  setHeader('model', browserName);
  setHeader('manufacturer', 'web_browser');
  setHeader('platform', osName);
};
